export class ListingsTabs {
    public static PartsWantedListings : number = 0;
    public static PartsForSalePending : number = 1;
    public static PartsForSaleClosed : number = 2;
    public static PurchasedParts : number = 3;
}